import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { NewRequestComponent } from '../app/shared-module/dialogs/new-request/new-request.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomSelectDirective } from '../app/shared-module/directives/custom-select.directive';
import { ForwardRequestPopupComponent } from '../app/shared-module/dialogs/forward-request-popup/forward-request-popup.component';
import { LeadProcessPopupComponent } from '../app/shared-module/dialogs/lead-process-popup/lead-process-popup.component';
import { PlaceInOrderPopupComponent } from '../app/shared-module/dialogs/place-in-order-popup/place-in-order-popup.component';
import { UndoAssignmentPopupComponent } from '../app/shared-module/dialogs/undo-assignment-popup/undo-assignment-popup.component';
import { RejectRequestPopupComponent } from '../app/shared-module/dialogs/reject-request-popup/reject-request-popup.component';
import { LeadTypePopupComponent } from '../app/shared-module/dialogs/lead-type-popup/lead-type-popup.component';
import { DateTimeComponent } from '../app/shared-module/date-pickers/date-time/date-time.component';
import { CloseRequestPopupComponent } from '../app/shared-module/dialogs/close-request-popup/close-request-popup.component';
import { AppointmentMovePopupComponent } from '../app/shared-module/dialogs/appointment-move-popup/appointment-move-popup.component';
import { OfferMovePopupComponent } from '../app/shared-module/dialogs/offer-move-popup/offer-move-popup.component';
import { OfferSubmitPopupComponent } from '../app/shared-module/dialogs/offer-submit-popup/offer-submit-popup.component';
import { AppointmentCreatePopupComponent } from '../app/shared-module/dialogs/appointment-create-popup/appointment-create-popup.component';
import {
  LeadReminderPopupComponent
} from '../app/shared-module/dialogs/lead-reminder-popup/lead-reminder-popup.component';
import { EditContactComponent } from '../app/shared-module/dialogs/edit-contact/edit-contact.component';
import { ContactFormComponent } from '../app/shared-module/components/contact-form/contact-form.component';
import { TranslationDirective } from '../app/shared-module/directives/translation.directive';
import { LeadStatusComponent } from '../app/shared-module/components/lead-status/lead-status.component';
import { AlertComponent } from '../app/shared-module/components/v2/alert/alert.component';
import { BadgeComponent } from '../app/shared-module/components/v2/badge/badge.component';
import { ButtonComponent } from '../app/shared-module/components/v2/button/button.component';
import { CheckboxComponent } from '../app/shared-module/components/v2/checkbox/checkbox.component';
import { SwitchComponent } from '../app/shared-module/components/v2/switch/switch.component';
import { RadioComponent } from '../app/shared-module/components/v2/radio/radio.component';
import { SelectionListComponent } from '../app/shared-module/components/v2/selection-list/selection-list.component';
import { EditorComponent } from '../app/shared-module/components/editor/editor.component';
import { OfferDelayPopupComponent } from '../app/shared-module/dialogs/offer-delay-popup/offer-delay-popup.component';
import { AddressEditorComponent } from '../app/shared-module/components/address-editor/address-editor.component';
import { ContactInfoComponent } from '../app/shared-module/dialogs/contact-info-component/contact-info.component';
import { ExternalEmailComponent } from '../app/shared-module/dialogs/external-email/external-email.component';
import { RequestContactsComponent } from '../app/shared-module/components/request-contacts/request-contacts.component';
import { ProgressSpinnerComponent } from '../app/shared-module/components/progress-spinner/progress-spinner.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DeleteContactComponent } from '../app/shared-module/dialogs/delete-contact/delete-contact.component';
import { A11yModule } from '@angular/cdk/a11y';
import { DragAndDropDirective } from '../app/shared-module/directives/drag-and-drop.directive';
import { DuplicateCheckComponent } from '../app/shared-module/dialogs/duplicate-check/duplicate-check.component';
import { NewEmailComponent } from '../app/shared-module/dialogs/new-email/new-email.component';
import { GeneralErrorComponent } from '../app/shared-module/dialogs/general-error/general-error.component';
import { NegotiationCreateComponent } from '../app/shared-module/dialogs/negotiation-create/negotiation-create.component';
import { MaintenanceModeComponent } from '../app/shared-module/dialogs/maintenance-mode/maintenance-mode.component';
import { NegotiationMoveComponent } from '../app/shared-module/dialogs/negotiation-move/negotiation-move.component';
import { MaskSearchedDirective } from "../app/shared-module/directives/mask-searched.directive";
import { ReopenRequestComponent } from '../app/shared-module/dialogs/reopen-request/reopen-request.component';
import { DuplicateContactComponent } from '../app/shared-module/dialogs/duplicate-check/duplicate-contact/duplicate-contact.component';
import { MatTabGroupSwipeDirective } from '../app/shared-module/directives/mat-tab-group-swipe.directive';
import { LeadTakeoverComponent } from '../app/shared-module/dialogs/lead-takeover/lead-takeover.component';
import {
  SendExternalEmailPopupComponent
} from '../app/shared-module/dialogs/send-external-email-popup/send-external-email-popup.component';
import { MatMenuModule } from "@angular/material/menu";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { ReplacePipe } from "../helper/replace.pipe";
import { AppCurrencyPipe } from "../helper/app-currency";
import { ToDistancePipe } from "../helper/to-distance.pipe";
import {
  LeadMultipleStepByStepComponent
} from '../app/shared-module/dialogs/lead-multiple-step-by-step/lead-multiple-step-by-step.component';
import { MatProgressBarModule } from "@angular/material/progress-bar";
import {
  LeadsMultipleStepByStepService
} from "../services/leads-multiple-step-by-step/leads-multiple-step-by-step.service";
import { GeneralMessageComponent } from '../app/shared-module/dialogs/general-message/general-message.component';
import { CustomInputComponent } from '../app/shared-module/components/v2/input/custom-input.component';
import { DayPickerComponent } from '../app/shared-module/components/v2/input/day-picker/day-picker.component';
import { DayRangePickerComponent } from '../app/shared-module/components/v2/input/day-range-picker/day-range-picker.component';
import { MatTabsModule } from '@angular/material/tabs';
import { EditLeadComponent } from '../app/shared-module/dialogs/edit-lead/edit-lead.component';
import {
  ComposerOfferOrderEditorComponent
} from '../app/shared-module/components/composer-offer-order-editor/composer-offer-order-editor.component';
import { InvitePlannerPopupComponent } from '../app/shared-module/dialogs/invite-planner-popup/invite-planner-popup.component';
import { VisitPlannerPopupComponent } from '../app/shared-module/dialogs/visit-planner-popup/visit-planner-popup.component';
import { CompendiumAllowPopupComponent } from '../app/shared-module/dialogs/compendium-allow-popup/compendium-allow-popup.component';
import { CompendiumDenyPopupComponent } from '../app/shared-module/dialogs/compendium-deny-popup/compendium-deny-popup.component';
import { AlertDialogComponent } from '../app/shared-module/dialogs/alert-dialog/alert-dialog.component';
import { CopyComponent } from '../app/shared-module/components/copy/copy.component';
import { SharedLeadCheckboxComponent } from '../app/shared-module/components/shared-lead-checkbox/shared-lead-checkbox.component';
import {
  CreateRequestFromComposerDialogComponent
} from '../app/shared-module/dialogs/create-request-from-composer/create-request-from-composer-dialog.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {
  ConsultationCreatePopupComponent
} from '../app/shared-module/dialogs/consultation-create-popup/consultation-create-popup.component';
import {
  LeadBrokerStartComponent
} from '../app/shared-module/dialogs/lead-broker-start/lead-broker-start.component';
import {
  LeadBrokerAbortComponent
} from '../app/shared-module/dialogs/lead-broker-abort/lead-broker-abort.component';

const MATERIAL_MODULES = [
  MatIconModule,
  MatButtonToggleModule,
  MatMenuModule,
  MatFormFieldModule,
  MatSelectModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatTabsModule,
  MatTooltipModule,
];

@NgModule({
  providers: [
    CurrencyPipe,
    LeadsMultipleStepByStepService,
  ],
  declarations: [
    NewRequestComponent,
    EditLeadComponent,
    CustomSelectDirective,
    ForwardRequestPopupComponent,
    LeadReminderPopupComponent,
    OfferDelayPopupComponent,
    AlertDialogComponent,
    AppointmentMovePopupComponent,
    AppointmentCreatePopupComponent,
    ConsultationCreatePopupComponent,
    LeadBrokerStartComponent,
    LeadBrokerAbortComponent,
    OfferMovePopupComponent,
    OfferSubmitPopupComponent,
    ComposerOfferOrderEditorComponent,
    CreateRequestFromComposerDialogComponent,
    LeadProcessPopupComponent,
    PlaceInOrderPopupComponent,
    UndoAssignmentPopupComponent,
    RejectRequestPopupComponent,
    LeadTypePopupComponent,
    CloseRequestPopupComponent,
    DateTimeComponent,
    LeadStatusComponent,
    AlertComponent,
    BadgeComponent,
    ButtonComponent,
    CheckboxComponent,
    SwitchComponent,
    RadioComponent,
    SelectionListComponent,
    EditorComponent,
    CustomInputComponent,
    DayPickerComponent,
    DayRangePickerComponent,
    AddressEditorComponent,
    EditContactComponent,
    ContactInfoComponent,
    ContactFormComponent,
    TranslationDirective,
    MaskSearchedDirective,
    MatTabGroupSwipeDirective,
    ExternalEmailComponent,
    RequestContactsComponent,
    ProgressSpinnerComponent,
    DeleteContactComponent,
    DragAndDropDirective,
    DuplicateCheckComponent,
    NewEmailComponent,
    GeneralErrorComponent,
    GeneralMessageComponent,
    InvitePlannerPopupComponent,
    VisitPlannerPopupComponent,
    CompendiumAllowPopupComponent,
    CompendiumDenyPopupComponent,
    NegotiationCreateComponent,
    MaintenanceModeComponent,
    NegotiationMoveComponent,
    ReopenRequestComponent,
    SendExternalEmailPopupComponent,
    DuplicateContactComponent,
    LeadTakeoverComponent,
    CopyComponent,
    SharedLeadCheckboxComponent,
    ReplacePipe,
    LeadMultipleStepByStepComponent,
    AppCurrencyPipe,
    ToDistancePipe,
  ],
  exports: [
    CustomSelectDirective,
    LeadStatusComponent,
    AlertComponent,
    EditorComponent,
    CustomInputComponent,
    DayPickerComponent,
    DayRangePickerComponent,
    AddressEditorComponent,
    DateTimeComponent,
    TranslationDirective,
    MaskSearchedDirective,
    EditContactComponent,
    ContactFormComponent,
    MatTabGroupSwipeDirective,
    ReplacePipe,
    ComposerOfferOrderEditorComponent,
    CopyComponent,
    SharedLeadCheckboxComponent,
    AppCurrencyPipe,
    ToDistancePipe,
  
    // v2 design-system components. These were declared but never exported,
    // which is why they had no usages outside this module.
    ButtonComponent,
    CheckboxComponent,
    SwitchComponent,
    RadioComponent,
    BadgeComponent,
    SelectionListComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ...MATERIAL_MODULES,
    A11yModule,
  ]
})
export class SharedModule {
}
